export const LogoMark = ({ className = "text-[#1E3A2B]", compact = false, showEst = false }) => (
  <span className={`inline-flex flex-col items-center leading-none select-none ${className}`} aria-hidden="true">
    <span className={`font-serif-brand font-semibold tracking-tight ${compact ? "text-lg" : "text-2xl"}`}>Aotea</span>
    <span className={`font-serif-brand font-semibold tracking-tight ${compact ? "text-lg -mt-1" : "text-2xl -mt-1.5"}`}>Biotech</span>
    {showEst && (
      <span className="font-mono-brand text-[8px] uppercase tracking-[0.3em] mt-1.5 opacity-70">EST. 2026</span>
    )}
  </span>
);
